'use strict';

/* global yith_wcaf */

import { $ } from '../../src/globals.js';
import { initFields } from './modules/fields';

$( () => initFields() );
